import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionType from 'utils/mw/actionType.util';
import asObject from 'utils/objects/asObject.util';

const ATAG = 'beTimeOffCategories';
const AT = actionType(ATAG);

const beTimeOffCategories = (options) =>
  endpoint(H.get, 'salon/v2/:salonId/time_off_categories/', {
    AT,
    name: ATAG,
    params: { salonId: asObject(options).salonId },
  });

beTimeOffCategories.AT = AT;
beTimeOffCategories.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beTimeOffCategories;
